var map = {
	"./ar/strings.json": 560,
	"./en/strings.json": 327,
	"./es/strings.json": 561,
	"./fr/strings.json": 562,
	"./ja/strings.json": 563,
	"./ko/strings.json": 564,
	"./pt_br/strings.json": 565,
	"./ru/strings.json": 566,
	"./tr/strings.json": 567,
	"./uk/strings.json": 568,
	"./zh_cn/strings.json": 569,
	"./zh_tw/strings.json": 570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1247;